import EventHandler from '@pixelunion/events';

import NavDesktopMenu from '../../snippets/navigation-desktop/NavDesktopMenu';
import NavMobile from '../../snippets/navigation-mobile/NavMobile';

export default class StaticHeader {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.events = new EventHandler();

    this.announcementBar = document.querySelector('.pxs-announcement-bar');
    this.headerControls = document.querySelector('[data-header-controls]');
    this.searchInput = this.headerControls.querySelector('[data-search-input]');

    this.header = this.el.querySelector('[data-site-header]');
    this.logo = this.el.querySelector('[data-header-logo]');
    this.navigation = this.el.querySelector('[data-navigation-desktop]');
    this.mobileNav = this.el.querySelector('[data-mobile-nav]');

    // We need to move the mobile nav in the dom to be outside of the header to allow for
    // appropriate z-index between the header controls, header, and mobile nav.
    this.mobileNav = document.body.insertBefore(this.mobileNav, this.el.nextSibling);

    this.navDesktopMenu = new NavDesktopMenu(this.navigation);
    this.navMobile = new NavMobile({
      controls: this.headerControls,
      mobileNav: this.mobileNav,
    });

    this.sticky = this.header.classList.contains('site-header--sticky');

    document.body.style.setProperty('--scroll-away-opacity', 1);

    // This is the logo height plus the announcement bar height to have the
    // scroll away opacity effect work better with images taller than 100px.
    // We also need to adjust the fade slightly because the logo does not
    // scroll completely away (10px).
    const barHeight = this.announcementBar ? this.announcementBar.getBoundingClientRect().height : 0;
    const fadeHeight = Math.max(this.logo.getBoundingClientRect().height + barHeight - 10, 100);

    this.events.register(window, 'scroll', () => {
      const opacity = Math.max(1 - (window.scrollY / fadeHeight), 0);
      document.body.style.setProperty('--scroll-away-opacity', opacity);

      if (this.sticky) {
        const searchBottom = this.searchInput.getBoundingClientRect().bottom;
        const navTop = this.navigation.getBoundingClientRect().top;

        if (searchBottom > navTop) {
          this.headerControls.classList.add('header-controls--search-overlap');
          this.header.classList.add('site-header--search-overlap');
        } else {
          this.headerControls.classList.remove('header-controls--search-overlap');
          this.header.classList.remove('site-header--search-overlap');
        }
      }
    });

    this.events.register(this.searchInput, 'focusin', () => {
      this.headerControls.classList.add('header-controls--search-active');
      this.header.classList.add('site-header--search-active');
    });

    this.events.register(this.searchInput, 'focusout', () => {
      this.headerControls.classList.remove('header-controls--search-active');
      this.headerControls.classList.remove('header-controls--search-overlap');
      this.header.classList.remove('site-header--search-active');
      this.header.classList.remove('site-header--search-overlap');
    });
  }

  onSectionBlockSelect(block) {
    this.navDesktopMenu.selectBlock(block.id);
  }

  onSectionBlockDeselect() {
    this.navDesktopMenu.closeAllMenus();
  }

  onSectionUnload() {
    this.navDesktopMenu.unload();
    this.navMobile.unload();
    this.events.unregisterAll();
  }
}
